import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  FETCH_CURRENT_PREFERENCES_SUCCESS,
  UPDATE_DASHBOARD_PREFERENCES_SUCCESS,
  UPDATE_THEME_PREFERENCES_SUCCESS,
  SHOW_SETTINGS_SUCCESS
} from "../sagas/dashboardConfigurator/dashboardConfigurator";
// Name Spaced Action Types
export const actions = {
  FETCH_CURRENT_PREFERENCES_SUCCESS,
  UPDATE_DASHBOARD_PREFERENCES_SUCCESS,
  UPDATE_THEME_PREFERENCES_SUCCESS,
  SHOW_SETTINGS_SUCCESS
};

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
export const actionCreators = {};

export const initialState = {
  preferences: [],
  showSettings: false,
  lightTheme: false
};

export default handleActions(
  {
    [FETCH_CURRENT_PREFERENCES_SUCCESS]: (state, action) => ({
      ...state,
      preferences: action.payload.dashboardPreferences || state.preferences,
      lightTheme: action.payload.theme === "dark" ? false : true || state.lightTheme,
      showSettings: state.showSettings
    }),
    [UPDATE_DASHBOARD_PREFERENCES_SUCCESS]: (state, action) => ({
      ...state,
      preferences: action.payload.dashboardPreferences || state.preferences,
      lightTheme: action.payload.theme === "dark" ? false : true || state.lightTheme,
      showSettings: state.showSettings
    }),
    [UPDATE_THEME_PREFERENCES_SUCCESS]: (state, action) => ({
      ...state,
      preferences: action.payload.dashboardPreferences || state.preferences,
      lightTheme: action.payload.theme === "dark" ? false : true || state.lightTheme,
      showSettings: state.showSettings
    }),
    [SHOW_SETTINGS_SUCCESS]: (state, action) => ({
      ...state,
      showSettings: action.payload.payload
    })
  },
  initialState
);
